
/**Imports standard que se usan en muchas ventanads */
import * as React from 'react';
export { React };

import * as models from "app/models/requireme";
export { models };

import * as kea from 'kea-react';
export { kea };

export { validation, formfields } from "kea-react"

import * as history from "app/main/history";
export { history };

import * as  selectores from "app/features/selectores/index";
export { selectores };

import * as resources from "app/resources/index";
export { resources };

import { mapState } from "react-mapstate";
export { mapStateUncontrolled } from "kea-react"
export { createSelectorRx } from "keautils";

import { Route, Redirect, withRouter, match, Switch } from "react-router";
import { BrowserRouter as router, Link as link, NavLink as navLink } from "react-router-dom";
export const Router = router;
export const Link = link;
export const NavLink = navLink;
export { Route, Redirect, withRouter, match, Switch };

import { componentToRx as componentToRxLoading } from "react-rxk";

export { fa } from "typed-font-awesome";
/**
 * Convert a react component to a one that accepts rxjs observable on all its props
 */
export function componentToRx<TProps>(component: (React.ComponentClass<TProps> | ((props: TProps) => (JSX.Element | null)))) {
    return componentToRxLoading(component, <kea.Spinner />);
}

export const fechaCarga = new Date();



// WEBPACK FOOTER //
// ./app/main/std.tsx